<template>
    <TMobileServices
        class="o-mobile-service mobile-service"
        color="#E25046"
        :footer-button-text="this.$t('ui.back')"
        :theme="'back'"
        @onFooterButton="handleClickBack"
    >
        <template #header>
            <AMHeaderItems
                :title="headerTitle"
                color="#E25046"
                right-slot
                @onClose="handleClose"
            >
                <template #left>
                    <AMBackButton
                        v-if="isLandscape"
                        theme="back"
                        :text="$t('ui.back')"
                        @onClick="handleClickBack"
                    />
                    <div 
                        v-else
                        class="m-header-items__icon-container"
                    >
                        <img 
                            :src="serviceIcon"
                            class="m-header-items__icon"
                            :alt="`${$t('m-header-items_icon')}`"
                        >
                    </div>
                </template>
                <template #right>
                    <AMBackButton
                        v-if="isLandscape"
                        :text="$t('ui.close')"
                        @onClick="handleClickBack"
                    />
                    <span 
                        v-else-if="!isCloseButtonShow"
                        class="m-header-items__info"
                    >
                        {{ objectCount }} st
                    </span>
                    <AMItemsCloseButton
                        v-if="!isLandscape && isCloseButtonShow"
                        @onClick="handleClickBack"
                    />
                </template>
            </AMHeaderItems>
        </template>
        <template #container>
            <RecycleScroller
                #default="{ item }"
                :items="items"
                :item-size="itemSize"
                class="mobile-service__scroller"
            >
                <OWServiceInfoTile
                    :item="item"
                    @onClick="handleTileClick"
                />
            </RecycleScroller>
        </template>
    </TMobileServices>
</template>

<script>
import sortBy from 'lodash/sortBy';

import { 
    mapState,
    mapGetters
} from 'vuex';

import AMBackButton from '../../atoms/a-m-back-button/a-m-back-button';
import AMHeaderItems from '../../atoms/a-m-header-items/a-m-header-items';
import TMobileServices from '../../templates/t-mobile-items/t-mobile-items';
import AMItemsCloseButton from '../../atoms/a-m-items-close-button/a-m-items-close-button';
import OWServiceInfoTile from '../../organisms/o-w-service-info-tile/o-w-service-info-tile';

import { GUIDE_NEW_POINT } from "@/utils/constants/bus-events-constants";
import {
    MOBILE_GUIDE, MOBILE_ROOT,
    MOBILE_SERVICE,
    MOBILE_SERVICES
} from '@/utils/constants/pages';

import { sortedItems } from '@/utils/helpers/sortedItems'

export default {
    name: 'OMService',
    data() {
        return {
            renderItems: 10
        }
    },
    components: {
        AMBackButton,
        AMHeaderItems,
        TMobileServices,
        OWServiceInfoTile,
        AMItemsCloseButton
    },
    props: {
        id: {
            type: [Number, String],
            default: null
        },
        isCloseButtonShow: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            isLandscape: state => state.landscape
        }),
        ...mapGetters([
            't',
            'getListItem',
            'getActiveLocale',
            'getObjectsByCategory'
        ]),
        itemId() {
            return this.$route.query.id ? this.$route.query.id : this.id
        },
        service() {
            return this.getListItem(parseInt(this.itemId));
        },
        items() {
            const items = [...sortBy(this.getObjectsByCategory(this.service.id), ["distance"])];

            return sortedItems(items, this.getActiveLocale)
        },
        headerTitle() {
            const t = this.t;
            const service = this.service;
            return this.isLandscape 
                ? t(service, 'name') + ' ' + t(service, 'objectsCount') + ' st'
                : t(service, 'name')
        },
        serviceIcon() {
            return this.t(this.service, 'icon') || '';
        },
        objectCount() {
            return this.t(this.service, 'objectsCount') || 0;
        },
        itemSize() {
            return this.isLandscape ? 40 : 97;
        }
    },
    methods: {
        handleClickBack() {
            if (this.$route.name === MOBILE_SERVICE) {
                const params = {
                    name: MOBILE_SERVICES
                };
                this.$router.push(params);
            } else {
                this.$emit('onClickBack', true);
            }
        },
        handleTileClick(data) {
            switch (this.$route.name) {
            case MOBILE_SERVICE:
                this.redirectToGuide(data);
                break;
            case MOBILE_GUIDE:
                this.changeExtremePoint(data);
                break;
            default:
                break;
            }
        },
        redirectToGuide(data) {
            const params = {
                name: MOBILE_GUIDE,
                params: {
                    type: 'service'
                },
                query: {
                    to: data.id
                }
            };
            this.$router.push(params);
        },
        changeExtremePoint(data) {
            this.$bus.$emit(GUIDE_NEW_POINT, data.id);
            this.$emit('changeExtremePoint');
        },
        handleClickClose() {
            this.$router.push({ name: MOBILE_ROOT });
        },
        handleClose() {
            this.$emit('onClickBack', true);
        }
    }
} 
</script>

<style lang="scss">
@import "o-m-service";   
</style>